import { AiMatchingScore } from "../../../pages";
import routesMap from "../../../routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: `${routesMap.AI_MATCHING_SCORE.path}/:id`,
      name: "Ai Matching Score",
      key: `${routesMap.AI_MATCHING_SCORE.path}/:id`,
      commonRoute: false,
      private: true,
      belongsToSidebar: false,
      element: <AiMatchingScore />,
    },
  ];
}
